import type { PageMetadata } from '../models/HostRoomBooking';
import type {
  AnyTutorBookingSummaryCountsResponse,
  TutorBookingFilter,
  TutorBookingsPageResponse,
} from '../models/Tutor';

export const USER_TUTOR_BOOKING_FILTERS: TutorBookingFilter[] = [
  'needs_user_action',
  'needs_tutor_action',
  'upcoming',
  'past',
  'cancelled',
  'all',
];

export const TUTOR_BOOKING_REQUEST_FILTERS: TutorBookingFilter[] = [
  'needs_tutor_action',
  'needs_user_action',
  'upcoming',
  'past',
  'cancelled',
  'all',
];

export const HOST_TUTOR_BOOKING_FILTERS: TutorBookingFilter[] = [
  'needs_tutor_action',
  'needs_user_action',
  'upcoming',
  'past',
  'cancelled',
  'all',
];

type PageLike = {
  content: unknown[];
  page?: PageMetadata;
  totalElements?: number;
};

export function extractTutorBookingsPageTotal(response: PageLike): number {
  return response.page?.totalElements ?? response.totalElements ?? response.content.length;
}

export function extractTutorBookingsPageTotalFromLegacy(response: TutorBookingsPageResponse): number {
  return extractTutorBookingsPageTotal(response);
}

export function getTutorBookingFilterCount(
  summary: AnyTutorBookingSummaryCountsResponse | null | undefined,
  filter: TutorBookingFilter,
): number {
  if (!summary) return 0;
  switch (filter) {
    case 'upcoming':
      return summary.upcoming;
    case 'past':
      return summary.past;
    case 'needs_tutor_action':
      return summary.needsTutorAction;
    case 'needs_user_action':
      return summary.needsUserAction;
    case 'pending':
      return summary.pending;
    case 'confirmed':
      return summary.confirmed;
    case 'cancelled':
      return summary.cancelled;
    case 'all':
      return summary.all;
    default:
      return 0;
  }
}
